/**
 * Phase 4.7.4 — Template Center user-facing label constants.
 *
 * Single source of truth for the visible label of the
 * "create a new project from a template" entrypoint.
 *
 * Locked rule: when the action opens Template Center or starts the
 * project-from-template flow, the visible label MUST be exactly
 * `NEW_TEMPLATE_ACTION_LABEL`. Do not hand-write the string in components.
 */
export const NEW_TEMPLATE_ACTION_LABEL = 'New Template';
